<template>
  <div class="page-account-binding">
    <div class="page-account-binding-item">
      <div class="left">
        <ym-icon class="wechat-icon"
                 name="weixinicon"
        />
        <div class="info">
          <div class="top">微信账号</div>
          <div v-if="wechatBound && nickname"
               class="bottom"
          >
            {{ nickname }}
          </div>
        </div>
      </div>
      <div v-if="loaded"
           class="right"
           :class="{ 'active': !wechatBound }"
           @click="handleBinding"
      >
        {{ wechatBound ? '解绑' : '绑定' }}
      </div>
    </div>
  </div>
</template>

<script>
  import {
    isWeiXinBrowser,
    locationHref,
    getQuery,
  } from '@/utils';
  import {
    getLoginWeChatUrl,
    getWeChatBindingStatus,
    removeWeChatBinding,
  } from '@/services/user';

  export default {
    name: 'PageAccountBinding',
    metaInfo: {
      title: '账号绑定',
    },
    data() {
      return {
        loaded: false,
        nickname: '',
        wechatBound: false,
        weChatLoginUrl: '',
      };
    },
    computed: {
      inWeChat() {
        return isWeiXinBrowser();
      },
      query() {
        return getQuery(this.$route.query);
      },
      agency() {
        return this.query && this.query.agency ? parseInt(this.query.agency, 10) : 0;
      },
    },
    methods: {
      handleBinding() {
        if (this.wechatBound) {
          this.removeWeChatBinding();
          return;
        }
        if (!this.inWeChat) {
          this.$toast('请前往少年商学院APP操作');
          setTimeout(() => {
            locationHref('https://oia.youthmba.com/download/app');
          }, 1500);
          return;
        }
        this.handleLoginWithWeChat();
      },
      async fetchData() {
        if (this.inWeChat) {
          const data = await getLoginWeChatUrl({
            redirectTo: '/account/binding',
            agency: this.agency,
          });
          this.weChatLoginUrl = data;
        }
      },
      async handleLoginWithWeChat() {
        if (this.weChatLoginUrl === '') await this.fetchData();
        locationHref(this.weChatLoginUrl, 'replace');
      },
      async getWeChatBindingStatus() {
        const data = await getWeChatBindingStatus();
        this.wechatBound = data.hasBind;
        this.nickname = data.nickname;
        this.loaded = true;
        if (!this.wechatBound) await this.fetchData();
      },
      async removeWeChatBinding() {
        await removeWeChatBinding();
        await this.getWeChatBindingStatus();
        this.$toast('解绑成功');
      },
    },
    created() {
      this.getWeChatBindingStatus();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-account-binding {
    min-height: 100%;
    background-color: #f5f6f7;
    &-item {
      height: 136px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      background-color: @color-white;
      padding: 0 30px;
      box-sizing: border-box;
      .left {
        display: flex;
        align-items: center;
        .wechat-icon {
          font-size: 48px;
          margin-right: 20px;
        }
        .info {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .top {
            color: @color-text-light;
            font-size: @font-size-base;
            line-height: 1;
          }
          .bottom {
            color: @color-text-lighter;
            font-size: @font-size-small;
            line-height: 1;
            margin-top: 12px;
          }
        }
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 50px;
        border-radius: 25px;
        box-sizing: border-box;
        border: 1px solid #02cccc;
        color: #13b9bf;
        font-size: 26px;
        &.active {
          background-color: #02cccc;
          border: none;
          color: @color-white;
        }
      }
    }
  }
</style>
